export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/practice_card_3-1d8669937ac8a9764cea220686fa8f9e.svg";